module.exports = __webpack_public_path__ + "static/media/shortlist.a959a091.png";